import axiosInstance from "../axiosInstance";

import type { TourImageUploadResponse, TourPolicyUpdateRequest } from "../types/tours.types";

const BASE = "/server/buccl_main/api/v1/travel-products/";

export const toursService = {
  list: (params?: Record<string, unknown>) => axiosInstance.get(BASE, { params }),
  get: (id: number) => axiosInstance.get(`${BASE}${id}/`),
  create: (payload: Record<string, unknown>) => axiosInstance.post(`${BASE}create/`, payload),
  update: (id: number, payload: Record<string, unknown>) =>
    axiosInstance.patch(`${BASE}${id}/update/`, payload),
  // 예약금 환불 규정·위약금 규정만 부분 수정 (works-228). 같은 update 엔드포인트, 생략 키 = 기존값 유지
  updatePolicies: (id: number, payload: TourPolicyUpdateRequest) => axiosInstance.patch<{ message: string }>(`${BASE}${id}/update/`, payload),
  disable: (id: number) => axiosInstance.delete(`${BASE}${id}/disable/`),
  participants: (id: number) => axiosInstance.get(`${BASE}${id}/participants/`),

  // 투어 전용 이미지 업로드 (대표 썸네일 / 상세 본문 공용).
  // BE: TravelProductImageUploadView — multipart, 필드명 `image`, 201 → { url, filename, size, message }
  uploadImage: (file: File) => {
    const fd = new FormData();
    fd.append("image", file);
    return axiosInstance.post<TourImageUploadResponse>(
      "/server/buccl_main/api/v1/upload-image/travel-product/",
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  // 출발일정
  listDepartures: (tourId: number) => axiosInstance.get(`${BASE}${tourId}/departures/`),
  createDeparture: (payload: Record<string, unknown>) =>
    axiosInstance.post(`${BASE}departures/create/`, payload),
  updateDeparture: (departureId: number, payload: Record<string, unknown>) =>
    axiosInstance.patch(`${BASE}departures/${departureId}/update/`, payload),
};
